import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EmptyComponent } from './component/empty/empty.component';
import { SignInComponent } from './component/sign-in/sign-in.component';
import { RedirectComponent } from './component/redirect/redirect.component';
import { HeaderComponent } from './component/header/header.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BootService } from './service/boot.service';
import { SidebarComponent } from './component/sidebar/sidebar.component';
import { ImpersonateComponent } from './component/impersonate/impersonate.component';
import { SortByPipe } from './pipe/sort-by.pipe';
import { NotificationComponent } from './component/notification/notification.component';
import { DemoRolesComponent } from './component/demo-roles/demo-roles.component';


@NgModule({
  declarations: [
    AppComponent,
    EmptyComponent,
    SignInComponent,
    RedirectComponent,
    HeaderComponent,
    SidebarComponent,
    ImpersonateComponent,
    SortByPipe,
    NotificationComponent,
    DemoRolesComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    { provide: APP_INITIALIZER, useFactory: (boot: BootService) => () => boot.load(), deps: [BootService], multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
